import { CurrencyTextField, NumberInput } from '@core/components/Inputs';
import { SelectAsyncInput } from '@core/components/Select';
import { Checkbox, FormControlLabel, Grid, makeStyles, Switch, Tooltip } from '@material-ui/core';
import situacaotributariaIPIApi from 'app/services/api/servicoFiscal/situacaoTributariaIPIApi';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '0.9em',
  },
  container: {
    display: 'inline-block',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const DadosFiscaisIpi = (context) => {
  const formik = useFormikContext();
  const classes = useStyles();

  const [toggle, setToggle] = useState(formik.values?.fiscal?.ipi?.situacaoTributaria !== null);

  const ipiSituacaoTributaria = formik.values?.fiscal?.ipi?.situacaoTributaria;
  useEffect(() => {
    formik.setFieldValue(`${context.name}.codigoTributario`, ipiSituacaoTributaria?.codigo);

    ipiSituacaoTributaria !== null && ipiSituacaoTributaria?.codigo !== undefined ? setToggle(true) : setToggle(false);
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ipiSituacaoTributaria]);

  const { errors, touched, submitCount } = formik;

  const _errors = {
    situacaoTributaria:
      (submitCount || touched?.fiscal?.ipi?.situacaoTributaria) && errors?.fiscal?.ipi?.situacaoTributaria,
    codigoEnquadramento:
      (submitCount || touched?.fiscal?.ipi?.codigoEnquadramento) && errors?.fiscal?.ipi?.codigoEnquadramento,
  };

  const maximo3DigitosEsquerda = (values) => {
    return !values.floatValue || values.floatValue < 10 ** 3;
  };

  return (
    <>
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            control={
              <Switch
                id={`${context.name}.possuiIpi`}
                name={`${context.name}.possuiIpi`}
                value={toggle}
                checked={toggle}
                onChange={({ target: { checked } }) => {
                  setToggle(checked);

                  if (checked === false) {
                    formik.setFieldValue(`${context.name}.situacaoTributaria`, null);
                    formik.setFieldValue(`${context.name}.codigoEnquadramento`, null);
                    formik.setFieldValue(`${context.name}.aliquota`, null);
                    formik.setFieldValue(`${context.name}.valorBc`, null);
                    formik.setFieldValue(`${context.name}.tributacaoExclusivaPorUnidade`, null);
                    formik.setFieldValue(`${context.name}`, {});
                  }
                }}
                color="primary"
              />
            }
            label="IPI"
          />
        </Grid>
        {toggle && (
          <>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <SelectAsyncInput
                id={`${context.name}.situacaoTributaria`}
                label="Situação tributária"
                value={formik.values?.fiscal?.ipi?.situacaoTributaria}
                error={_errors.situacaoTributaria}
                touched={!!_errors.situacaoTributaria}
                onBlur={formik.handleBlur}
                renderOption={(option) => {
                  const labelOption =
                    option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
                  return (
                    <Tooltip title={labelOption}>
                      <div className={classes.container} style={{ maxWidth: '100%' }}>
                        {labelOption}
                      </div>
                    </Tooltip>
                  );
                }}
                onChange={(event, value) => {
                  formik.setFieldValue(`${context.name}.situacaoTributaria.id`, value?.id);
                  formik.setFieldValue(`${context.name}.situacaoTributaria.codigo`, value?.codigo);
                  formik.setFieldValue(`${context.name}.situacaoTributaria.descricao`, value?.descricao);

                  formik.setFieldValue(`${context.name}.codigoEnquadramento`, null);
                  formik.setFieldValue(`${context.name}.aliquota`, null);
                  formik.setFieldValue(`${context.name}.valorBc`, null);
                  formik.setFieldValue(`${context.name}.tributacaoExclusivaPorUnidade`, null);
                }}
                getOptionKey={(option) => {
                  return option?.id;
                }}
                getOptionLabel={(option) => {
                  return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
                }}
                fetchData={async (query = '', next = 0) => {
                  if (typeof query === 'object') {
                    query = '';
                  }
                  const response = await situacaotributariaIPIApi.search({
                    size: 100,
                    sort: 'codigo',
                    page: next,
                    q: query,
                  });

                  const data = response?.data || [];

                  return { data };
                }}
                required
                fetchOnFocus
              />
            </Grid>
            {toggle &&
              (formik.values?.fiscal?.ipi?.situacaoTributaria?.codigo >= '50' ||
                formik.values?.fiscal?.ipi?.situacaoTributaria?.codigo <= '99') && (
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                  <NumberInput
                    label="Código de enquadramento"
                    isAllowed={maximo3DigitosEsquerda}
                    required
                    allowNegative={false}
                    id={`${context.name}.codigoEnquadramento`}
                    value={formik.values?.fiscal?.ipi?.codigoEnquadramento}
                    onChange={formik.handleChange}
                    error={_errors.codigoEnquadramento}
                    touched={!!_errors.codigoEnquadramento}
                    onBlur={formik.handleBlur}
                  />
                </Grid>
              )}
          </>
        )}
        {toggle &&
          (formik.values?.fiscal?.ipi?.situacaoTributaria?.codigo === '50' ||
            formik.values?.fiscal?.ipi?.situacaoTributaria?.codigo === '99') && (
            <>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <NumberInput
                  label="Alíquota (%)"
                  decimalScale={4}
                  allowNegative={false}
                  isAllowed={maximo3DigitosEsquerda}
                  decimalSeparator=","
                  id={`${context.name}.aliquota`}
                  value={formik.values?.fiscal?.ipi?.aliquota}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <CurrencyTextField
                  label="Valor da BC do IPI (R$)"
                  variant="outlined"
                  id={`${context.name}.valorBc`}
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  maximumValue="99999999999.99"
                  minimumValue="0"
                  decimalPlaces={2}
                  currencySymbol=""
                  fullWidth
                  value={formik.values?.fiscal?.ipi?.valorBc}
                  onChange={(e, value) => {
                    formik.setFieldValue(`${context.name}.valorBc`, value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  label="Produto cuja tributação é exclusiva por unidade"
                  control={
                    <Checkbox
                      color="primary"
                      checked={formik.values?.fiscal?.ipi?.tributacaoExclusivaPorUnidade}
                      onChange={(event) => {
                        event.target.checked === true
                          ? formik.setFieldValue(`${context.name}.tributacaoExclusivaPorUnidade`, true)
                          : formik.setFieldValue(`${context.name}.tributacaoExclusivaPorUnidade`, false);
                      }}
                    />
                  }
                />
              </Grid>
            </>
          )}
      </Grid>
    </>
  );
};

export default DadosFiscaisIpi;
